<div class="schedule-dialog">
  <div class="dialog-header">
    <div>
      <h2 mat-dialog-title>Schedule Details</h2>
      <div class="subtitle">Availability, slots, and calendar preview</div>
    </div>
    <mat-chip [class.inactive]="schedule.active === false">{{ activeLabel }}</mat-chip>
  </div>

  <mat-dialog-content>
    <div class="summary-grid">
      <div class="summary-item">
        <span>Practitioner</span>
        <div>
          <strong [appReferenceDisplay]="actorReference" [instantFetchAndReplace]="true">{{ actorReference || 'N/A' }}</strong>
          <div style="font-size: 12px; color: #7f8c8d; margin-top: 2px; font-weight: normal;" *ngIf="(actorReference | referenceIdentifier | async) as identifier">
            ID: {{ identifier }}
          </div>
        </div>
      </div>
      <div class="summary-item">
        <span>Start</span>
        <strong>{{ schedule.planningHorizon?.start | date:'mediumDate' }}</strong>
      </div>
      <div class="summary-item">
        <span>End</span>
        <strong>{{ schedule.planningHorizon?.end | date:'mediumDate' }}</strong>
      </div>
      <div class="summary-item">
        <span>Slots</span>
        <strong>{{ totalSlots }} total, {{ freeSlots }} free, {{ busySlots }} busy</strong>
      </div>
    </div>

    @if(schedule.comment) {
    <div class="comment-block">
      <span>Comment</span>
      <p>{{ schedule.comment }}</p>
    </div>
    }

    <mat-divider></mat-divider>

    <div class="preview-cards-wrapper">
      <div class="calendar-preview">
        <mat-calendar [selected]="selectedDate" [startAt]="calendarStartAt" [dateClass]="dateClass"
          (selectedChange)="onDateSelected($event)">
        </mat-calendar>
      </div>

      <div class="time-preview">
        <div class="time-preview-title">
          @if(selectedDate) {
          Slots for {{ selectedDate | date:'mediumDate' }}
          } @else {
          Select a date to view slots
          }
        </div>

        @if(loadingSlots) {
        <div class="empty-panel">
          <mat-progress-spinner mode="indeterminate" diameter="26"></mat-progress-spinner>
          <span>Loading slots...</span>
        </div>
        } @else if(filteredSlots.length > 0) {
        <div class="slot-list">
          @for(slot of filteredSlots; track slot.id || $index) {
          <div class="slot-row" [class.busy]="slot.status !== 'free'">
            <div>
              <strong>{{ formatSlotTime(slot) }}</strong>
              <span>{{ slot.status || 'unknown' }}</span>
            </div>
            @if(slot.status === 'free') {
            <mat-icon>check_circle</mat-icon>
            } @else {
            <mat-icon>event_busy</mat-icon>
            }
          </div>
          }
        </div>
        } @else if(selectedDate) {
        <div class="empty-panel">No slots on this date.</div>
        } @else {
        <div class="empty-panel">Choose a highlighted day.</div>
        }
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
